import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';

import RangeInput from '../../ui/RangeInput';

import TaraText from './TaraText';

const Row = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  animationDelay: '1600ms',
});

const styleDoubleSpaced = {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 32,
};

const noop = () => {};

class TaraQuestionPrice extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
  };

  static defaultProps = {
    onChange: noop,
  };

  render() {
    if (!this.props.persona || !this.props.quantity) {
      return null;
    }

    const { priceLow, priceHigh, isAnimated, } = this.props;

    return (
      <div style={styleDoubleSpaced}>
        <TaraText
          isQuestion
          isAnimated={isAnimated}
        >
          &hellip; and finally, what&apos;s your <strong>budget</strong> for tickets?
        </TaraText>
        <Row className={isAnimated ? 'animated fadeIn' : undefined}>
          <RangeInput
            min={1}
            max={5}
            defaultValue={[priceLow, priceHigh]}
            onChange={this.props.onChange}
            tipFormatter={(value) => (new Array(value + 1)).join('$')}
          />
        </Row>
      </div>
    );
  }
}

export default TaraQuestionPrice;



// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraQuestionPrice.js